<template>
  <v-container class="ma-0 pa-0">
    <hero title="About"></hero>
    <v-row>
      <v-col class="mt-10 ma-3 about-text">
        <p><strong>Lava for Good</strong>, Adweek's 2024 Podcast Network of the Year, creates standout original content, podcasts, and experiences that deliver unparalleled access and insights into the heart of social justice in America, and inspire action towards a more informed, empathic, and just society.
        </p>
        <p>Founded and led by renowned music executive, children's book author, and philanthropist Jason Flom with Lava Media COO Jeff Kempler, Lava for Good's #1-charting lineup of podcasts, produced in association with Signal Co. No1, has been downloaded over 70 million times, listed by critics as among the best podcasts of all time, and is credited with influencing exonerations, clemencies, pardons, legislation and reforms nationwide. The lineup, hosted by leading experts, attorneys, activists, formerly incarcerated persons, and journalists on the frontlines of human rights and justice movements, includes <em>Bone Valley</em>, <em>Earwitness</em>, <em>Erased: The Murder of Elma Sands</em> (with Allison Williams and Tony Goldwyn), <em>False Confessions</em>, <em>Junk Science</em>, <em>The War on Drugs</em>, <em>Wrongful Conviction</em>, and more, and is available on all popular podcast platforms.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="ma-3">
      <h2>Contact</h2>
        <ul style="list-style: none">
          <li><a href="mailto:info@signalco1.com">Sponsorship / Inquiries</a></li>
          <li><a href="mailto:nathaniel@lavaforgood.com">Media</a></li>
          <li><a href="https://innocencenetwork.org/"  target="_new">Legal Resources</a></li>
          <li><a href="https://forms.gle/LdNn1tTxRgKuCMpYA/"  target="_new">Click here</a> to submit a case for consideration on Wrongful Conviction.</li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'About',
  metaInfo: {
    title: 'About',
    meta: [
      { vmid: 'og:title', property: 'og:title', content: 'About'},
    ]
  },
}
</script>
<style lang="sass">
a
  text-decoration: none
.about-text
  font-size: 1.1rem
  color: #dcdcdc
</style>

